<template>
    <v-container fluid class="pa-0">
        <v-row dense align="center">
            <v-col cols="12" sm="6" md="6" lg="1">
                <v-icon color="secondary" class="mb-2" x-large @click="goBackwards()">
                    mdi-chevron-left-circle
                </v-icon>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="11">
                <v-container fluid class="pa-0 mb-1">
                    <v-row justify="end" dense>
                        <v-col cols="12" lg="4" xl="3">
                            <v-select
                                v-model="filters.productionDepartment_id"
                                :items="productionDepartments"
                                item-value="id"
                                item-text="name"
                                placeholder="Dział"
                                no-data-text="Brak danych..."
                                hide-details
                                solo
                                @change="getProductionSitesGroups"
                            />
                        </v-col>
                        <v-col cols="12" lg="4" xl="3">
                            <v-select
                                v-model="filters.productionSiteGroup_id"
                                placeholder="Grupa stanowisk"
                                :items="productionSiteGroups"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono grupy stanowisk"
                                solo
                                hide-details
                                @click:clear="clearFilter('productionSiteGroup_id')"
                                @change="changeFilter"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-iterator
                    :items="machinesDashboard.body.data.results"
                    item-key="name"
                    :items-per-page.sync="pagination.itemsPerPage"
                    :page.sync="pagination.page"
                    :server-items-length.sync="pagination.itemsLength"
                    hide-default-footer
                >
                    <template #default="props">
                        <v-row>
                            <v-col
                                v-for="(machine, machineIndex) in props.items"
                                :key="machineIndex"
                                cols="12"
                                sm="6"
                                lg="3"
                            >
                                <v-card>
                                    <v-toolbar flat dense color="grey lighten-4">
                                        <v-container fluid class="pa-0">
                                            <v-row>
                                                <v-col cols="1">
                                                    <v-tooltip :open-delay="tooltipDelay" top>
                                                        <template #activator="{on}">
                                                            <v-btn
                                                                :disabled="!machine.user"
                                                                color="primary"
                                                                small
                                                                icon
                                                                tile
                                                                data-sentry-label="Przejdź do raportu zbiorczego"
                                                                
                                                                v-on="on"
                                                                @click="openReportShiftSummary(machine.machine.id)"
                                                            >
                                                                <v-icon>mdi-text-box</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Przejdź do raportu</span>
                                                    </v-tooltip>
                                                </v-col>
                                                <v-col cols="10">
                                                    <v-toolbar-title v-if="machine.machine" class="text-subtitle-1">
                                                        {{ machine.machine.name }}
                                                    </v-toolbar-title>
                                                </v-col>
                                                <v-col cols="1">
                                                    <v-row justify="end" dense>
                                                        <span>
                                                            <v-icon v-if="machine.currentProcess != '-'" color="success">
                                                                mdi-checkbox-marked-circle
                                                            </v-icon>
                                                            <v-icon v-else color="error">
                                                                mdi-alert-circle
                                                            </v-icon>
                                                        </span>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-toolbar>
                                    <v-divider />
                                    <v-card-text>
                                        <div v-if="machine">
                                            <div>
                                                <p class="my-1">
                                                    Zadanie: <strong>{{ machine.objectNumber }}</strong>
                                                </p>
                                            </div>
                                            <div>
                                                <p class="my-1">
                                                    Czynność: <strong>{{ machine.currentProcess }}</strong>
                                                </p>
                                            </div>
                                            <div>
                                                <p class="my-1">
                                                    Od kiedy: <strong>{{ formatDate(machine.currentProcessStartDateTime) }}</strong>
                                                </p>
                                            </div>
                                            <div>
                                                <p class="my-1">
                                                    Użytkownik: <strong v-if="machine.user">{{ machine.user }}</strong><strong v-else>-</strong>
                                                </p>
                                            </div>
                                        </div>
                                        <div v-else class="text-center">
                                            <strong>Maszyna wolna</strong>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </template>

                    <template #footer="props">
                        <v-row
                            class="mt-2"
                            align="center"
                            justify="center"
                            no-gutters
                        >
                            <span class="grey--text">Ilość wyświetlanych elementów</span>
                            <v-menu offset-y>
                                <template #activator="{on, attrs}">
                                    <v-btn
                                        dark
                                        text
                                        color="primary"
                                        class="ml-2"
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        {{ props.pagination.itemsPerPage }}
                                        <v-icon>mdi-chevron-down</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                        v-for="(number, index) in localFooterProps.itemsPerPageOptions"
                                        :key="index"
                                        @click="updateItemsPerPage(number, props.pagination)"
                                    >
                                        <v-list-item-title>{{ number }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>

                            <v-spacer />

                            <span
                                class="mr-4
                                grey--text"
                            >
                                Strona {{ props.pagination.page }} z {{ numberOfPages }}
                            </span>
                            <v-btn
                                small
                                rounded
                                color="primary"
                                class="mr-1"
                                :disabled="canChangeToPrevious || actionLoading"
                                @click="previousPage(props.pagination)"
                            >
                                <v-icon color="white">
                                    mdi-chevron-left
                                </v-icon>
                            </v-btn>
                            <v-btn
                                small
                                rounded
                                color="primary"
                                class="mr-1"
                                :disabled="canChangeToNext || actionLoading"
                                @click="nextPage(props.pagination)"
                            >
                                <v-icon color="white">
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                        </v-row>
                    </template>
                </v-data-iterator>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import router from '@/router'
import store from '@/store'
import dateFormatter from '@/mixins/dateFormatter'
import pagination from '@/mixins/dataTablePagination'
import filters from '@/mixins/dataTableFilters'
import { appConfig } from '@/config'
import { errorHandler } from '@/utils/errorHandler'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'MachineReview',
    mixins: [
        dateFormatter,
        pagination,
        filters,
        tooltipDelay,
    ],
    data() {
        return {
            actionLoading: false,
            numberOfPages: null,
            reportShiftSummaryId: null,
        }
    },
    computed: {
        productionSiteGroups() {
            return this.$store.state.configurations.productionSites.productionSiteGroups
        },
        machinesDashboard() {
            return this.$store.state.dashboard.dashboard.machinesDashboard
        },
        productionDepartments() {
            return this.$store.state.administration.users.productionDepartments
        },
        localFooterProps() {
            return {
                itemsPerPageOptions: appConfig.dashboards.rowsPerPageItems
            }
        },
        savedFilters() {
            return this.$store.state.dashboard.dashboard.filters
        },
        canChangeToNext() {
            return this.pagination.page === this.numberOfPages
        },
        canChangeToPrevious() {
            return this.pagination.page === 1
        }
    },
    mounted() {
        this.filters.productionSiteGroup_id = null
    },
    created() {
        this.pagination = store.state.dashboard.dashboard.pagination
        this.paginationSettings = store.state.dashboard.dashboard.paginationSettings
        this.clearPaginationPending()
        this.setNumberOfPages()
    },
    methods: {
        getProductionSitesGroups() {
            this.filters.productionSiteGroup_id = null
            this.$store.dispatch('configurations/getProductionSitesGroups', {
                query: `?productionDepartment_id=${this.filters.productionDepartment_id}`
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        setNumberOfPages() {
            const length = this.pagination.itemsLength, perPage = this.pagination.itemsPerPage
            
            this.numberOfPages = (length <= perPage) ? 1 : Math.ceil(length / perPage)
        },
        getMachinesWidgets() {
            store.dispatch('toggleMainLoader', true)
            let productionSiteGroupQuery = this.filters.productionSiteGroup_id ? `&productionSiteGroup_id=${this.filters.productionSiteGroup_id}` : ''
            
            this.actionLoading = true
            this.$store.dispatch('dashboard/getDashboardItem', {
                item: this.machinesDashboard,
                paginate: this.paginate(),
                query: `${productionSiteGroupQuery}&showInDashboard=true`
            })
                .then(response => {
                    this.handlePaginationResponse(response.data.body)
                    this.setNumberOfPages()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    store.dispatch('toggleMainLoader', false)
                    this.actionLoading = false
                })
        },
        goBackwards() {
            this.$emit('go-backwards')
        },
        changeFilter() {
            this.$store.dispatch('dashboard/setDashboardFilters', this.filters)
                .catch(error => {
                    errorHandler(error)
                })
            this.paginationSettings = {}
            this.pagination.page = 1
            this.getMachinesWidgets()
        },
        nextPage(pagination) {
            pagination.page +=1
            this.updatePagination(pagination)
        },
        previousPage(pagination) {
            pagination.page -=1
            this.updatePagination(pagination)
        },
        updateItemsPerPage(number, pagination) {
            pagination.itemsPerPage = number
            this.paginationSettings = {}
            pagination.page = 1
            this.updatePagination(pagination)
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getMachinesWidgets()
            }
            this.clearPaginationPending()
        },
        openReportShiftSummary(machineId) {
            store.dispatch('toggleMainLoader', true)
            this.$store.dispatch('reports/getSimpleReports', {
                paginate: '?limit=1',
                query: `$&machineId=${machineId}&statusId=1`
            })
                .then(response => {
                    this.reportShiftSummaryId = response.data.results[0]['reportShiftSummaryId']
                })
                .catch(error => errorHandler(error))
                .finally(() => {
                    if (!this.reportShiftSummaryId) {
                        this.$store.dispatch('showNotification', {
                            type: 'error',
                            message: 'Nie znaleziono raportu zmianowego.'
                        })
                    } else {
                        router.push({
                            name: 'reportsReportsShiftSummariesDetailedReports',
                            params: {
                                id: this.reportShiftSummaryId
                            }
                        })
                            .catch(error => errorHandler(error))
                    }
                })
        },
    }
}
</script>
